/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResult,
  Result,
  ResultOfContentManagerSingleDocumentViewModel,
  ResultOfProductDocumentViewModel,
  UpdateProductDocumentViewModel,
} from '../models';
import {
    ErrorResultFromJSON,
    ErrorResultToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfContentManagerSingleDocumentViewModelFromJSON,
    ResultOfContentManagerSingleDocumentViewModelToJSON,
    ResultOfProductDocumentViewModelFromJSON,
    ResultOfProductDocumentViewModelToJSON,
    UpdateProductDocumentViewModelFromJSON,
    UpdateProductDocumentViewModelToJSON,
} from '../models';

export interface DocumentsDeleteRequest {
    productDocumentId: number;
    productId: number;
}

export interface DocumentsDownloadRequest {
    contentManagerId: string;
}

export interface DocumentsPatchRequest {
    id: number;
    model: UpdateProductDocumentViewModel;
}

/**
 * 
 */
export class DocumentsApi extends runtime.BaseAPI {

    /**
     * Delete a product document.
     */
    async documentsDeleteRaw(requestParameters: DocumentsDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.productDocumentId === null || requestParameters.productDocumentId === undefined) {
            throw new runtime.RequiredError('productDocumentId','Required parameter requestParameters.productDocumentId was null or undefined when calling documentsDelete.');
        }

        if (requestParameters.productId === null || requestParameters.productId === undefined) {
            throw new runtime.RequiredError('productId','Required parameter requestParameters.productId was null or undefined when calling documentsDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/documents/{productDocumentId}/{productId}`.replace(`{${"productDocumentId"}}`, encodeURIComponent(String(requestParameters.productDocumentId))).replace(`{${"productId"}}`, encodeURIComponent(String(requestParameters.productId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Delete a product document.
     */
    async documentsDelete(requestParameters: DocumentsDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.documentsDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a product document.
     */
    async documentsDownloadRaw(requestParameters: DocumentsDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfContentManagerSingleDocumentViewModel>> {
        if (requestParameters.contentManagerId === null || requestParameters.contentManagerId === undefined) {
            throw new runtime.RequiredError('contentManagerId','Required parameter requestParameters.contentManagerId was null or undefined when calling documentsDownload.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/documents/download/{contentManagerId}`.replace(`{${"contentManagerId"}}`, encodeURIComponent(String(requestParameters.contentManagerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfContentManagerSingleDocumentViewModelFromJSON(jsonValue));
    }

    /**
     * Get a product document.
     */
    async documentsDownload(requestParameters: DocumentsDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfContentManagerSingleDocumentViewModel> {
        const response = await this.documentsDownloadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a product document.
     */
    async documentsPatchRaw(requestParameters: DocumentsPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfProductDocumentViewModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling documentsPatch.');
        }

        if (requestParameters.model === null || requestParameters.model === undefined) {
            throw new runtime.RequiredError('model','Required parameter requestParameters.model was null or undefined when calling documentsPatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/documents/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProductDocumentViewModelToJSON(requestParameters.model),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfProductDocumentViewModelFromJSON(jsonValue));
    }

    /**
     * Update a product document.
     */
    async documentsPatch(requestParameters: DocumentsPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfProductDocumentViewModel> {
        const response = await this.documentsPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
